<div class="lg:col-start-3 lg:row-end-1">
  <div
    class="rounded-lg bg-surface shadow-sm ring-1 ring-outline/20"
    [class.bg-surface-hover]="!(position.isActive === undefined ? true : position.isActive)"
  >
    <div class="flex flex-wrap">
      <div class="flex-auto pl-6 pt-6">
        <div class="flex gap-2">
          <div class="text-xs/6 font-semibold text-fg-secondary uppercase tracking-wide">
            {{ position.type === 'effort' ? 'Aufwand' : 'Fixpreis' }}
          </div>
          @if (position.billable) {
            <div
              class="sm:hidden inline-flex items-center rounded-md bg-green-50 dark:bg-green-900/30 px-2 py-1 text-xs font-medium text-green-700 dark:text-green-300 ring-1 ring-inset ring-green-600/20"
            >
              Verrechenbar
            </div>
          }
        </div>
        <dd
          class="mt-1 text-base font-bold text-fg-primary flex items-center gap-2"
          [class.text-fg-muted]="!(position.isActive === undefined ? true : position.isActive)"
        >
          {{ position.name }}
          @if (userId) {
            <app-favorite
              [userId]="userId"
              [favorite]="position.favorite ?? {}"
              (stateChange)="favoriteChanged.emit($event)"
            ></app-favorite>
          }
        </dd>
      </div>
      @if (position.billable) {
        <div class="hidden sm:block flex-none px-6 pt-4">
          <dt class="sr-only">Status</dt>
          <dd
            class="inline-flex items-center rounded-md bg-green-50 dark:bg-green-900/30 px-2 py-1 text-xs font-medium text-green-700 dark:text-green-300 ring-1 ring-inset ring-green-600/20"
          >
            Verrechenbar
          </dd>
        </div>
      }
      @if (position.type === 'effort') {
        <div class="sm:hidden flex-auto pl-6 pt-6 text-right pr-6">
          <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">
            Stunden geleistet
          </dt>
          <dd class="w-full flex-none text-xl/8 font-medium tracking-tight text-fg-primary">
            {{ position.totalWorkMinutes | formatWork }}
          </dd>
        </div>
      }
    </div>

    <div class="mt-3 grid gap-x-12 border-t border-edge px-6 pt-6 sm:grid-cols-3">
      <div class="text-fg-muted">
        <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">Beschreibung</dt>
        @if (position.description) {
          <dd class="mt-2 whitespace-pre-line">
            {{ position.description }}
          </dd>
        } @else {
          <button
            (click)="modifyPosition.emit(position)"
            class="mb-2 text-fg-muted w-full h-full sm:opacity-0 sm:hover:opacity-100 flex sm:hover:bg-surface-hover items-center justify-center rounded-sm"
          >
            <app-ng-icon class="text-[24px] text-fg-faint" name="heroPencil"></app-ng-icon>
          </button>
        }
      </div>

      <div class="col-span-2 mt-4 sm:mt-0 hidden sm:block">
        <div class="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-4">
          @if (position.type === 'effort') {
            <div class="flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">Stundensatz</dt>
              <dd class="w-full flex-none text-xl font-medium tracking-tight text-fg-primary">
                {{ position.hourlyRate }}
              </dd>
            </div>
          }
          @if (position.type === 'effort') {
            <div class="flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">
                Stunden offeriert
              </dt>
              <dd class="w-full flex-none text-xl/10 font-medium tracking-tight text-fg-primary">
                {{ position.estimatedWorkMinutes | formatWork }}
              </dd>
            </div>
          }
          @if (position.type === 'effort') {
            <div class="flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">
                Stunden geleistet
              </dt>
              <dd class="w-full flex-none text-xl/10 font-medium tracking-tight text-fg-primary">
                {{ position.totalWorkMinutes | formatWork }}
              </dd>
            </div>
          }
          @if (position.type === 'effort') {
            <div class="flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">
                Stunden verrechnet
              </dt>
              <dd class="w-full flex-none text-xl/10 font-medium tracking-tight text-fg-primary">
                {{ position.billedWorkMinutes | formatWork }}
              </dd>
            </div>
          }
          @if (position.type === 'fixed') {
            <div class="lg:col-start-2 flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">
                Stunden geleistet
              </dt>
              <dd class="w-full flex-none text-xl/10 font-medium tracking-tight text-fg-primary">
                {{ position.totalWorkMinutes | formatWork }}
              </dd>
            </div>
          }
          @if (position.type === 'fixed') {
            <div class="flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">Fixpreis</dt>
              <dd class="w-full flex-none text-xl/10 font-medium tracking-tight text-fg-primary">
                {{ position.amount | formatAmount }}
              </dd>
            </div>
          }
          @if (position.type === 'fixed') {
            <div class="flex flex-wrap items-baseline justify-between gap-x-4">
              <dt class="min-w-0 truncate text-xs/6 font-medium text-fg-secondary">Verrechnet</dt>
              <dd class="w-full flex-none text-xl/10 font-medium tracking-tight text-fg-primary">
                {{ position.billedAmount | formatWork }}
              </dd>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="mt-6 flex items-center justify-between border-t border-edge px-6 py-5">
      <button (click)="showWork.emit(position)" class="text-sm/6 text-fg-primary">
        Stunden <span aria-hidden="true">&rarr;</span>
      </button>
      <div class="flex gap-4">
        <button
          type="button"
          appTailwindButton
          color="white"
          size="xs"
          (click)="createWork.emit(position)"
        >
          Stunden erfassen
        </button>
        <button
          type="button"
          appTailwindButton
          color="secondary"
          size="xs"
          (click)="modifyPosition.emit(position)"
        >
          Bearbeiten
        </button>
      </div>
    </div>
  </div>
</div>
